import { render, staticRenderFns } from "./ExpiredReservationPage.vue?vue&type=template&id=5e20c3f7&"
import script from "./ExpiredReservationPage.vue?vue&type=script&lang=ts&"
export * from "./ExpiredReservationPage.vue?vue&type=script&lang=ts&"
import style0 from "./ExpiredReservationPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
